// <Se permissao="..."> — wrapper condicional baseado em permissoes granulares.
//
// Uso:
//   <Se permissao="operacional.contrato.aba.financeiro.ver">
//     <AbaFinanceiroResumo contrato={contrato} />
//   </Se>
//
// Se o usuario nao tem a permissao, nao renderiza nada (ou o fallback).
// Enquanto as permissoes carregam, NAO renderiza (evita flash de conteudo
// que vai sumir). Use `fallback` se quiser placeholder durante carregamento.

import { ReactNode } from 'react';
import { usePerms } from '../hooks/usePerms';

interface SeProps {
  permissao: string;
  children: ReactNode;
  fallback?: ReactNode;
}

export function Se({ permissao, children, fallback = null }: SeProps) {
  const { pode, carregando } = usePerms();
  if (carregando) return <>{fallback}</>;
  return pode(permissao) ? <>{children}</> : <>{fallback}</>;
}
